import { parsePhoneNumbers, serializePhoneNumber } from '../../../../utils/phoneNumberUtils';

export const transformPersonalInformation = (data = {}, dp = null) => {
  const phoneNumbers = data.phoneNumbers ?? [];
  const emailIds = data.emailIds ?? [];

  let transformedData = {
    candidate: {
      personalDetails: {
        displayPic: dp,
        salutation: data.salutation ?? '',
        firstName: data.firstName ?? '',
        middleName: data.middleName ?? '',
        lastName: data.lastName ?? '',
        dateOfBirth: data.dob ?? null,
        gender: data.gender ?? '',
        maritalStatus: data.maritalStatus ?? '',
        primaryPhoneNumber: serializePhoneNumber(phoneNumbers[0] ?? ''),
        primaryEmailId: emailIds[0] ?? '',
        alternatePhoneNumbers: serializePhoneNumber(phoneNumbers.slice(1) ?? []),
        alternateEmailIds: emailIds.slice(1) ?? [],
        currentAddress: {
          address1: data.address1 ?? '',
          address2: data.address2 ?? '',
          city: data.city ?? '',
          state: data.state ?? '',
          pinCode: data.pincode ?? '',
          country: data.country ?? '',
        },
        permanentAddress: data.isDifferentPermanentAddress
          ? {
            address1: data.permAddress1 ?? '',
            address2: data.permAddress2 ?? '',
            city: data.permCity ?? '',
            state: data.permState ?? '',
            pinCode: data.permPincode ?? '',
            country: data.permCountry ?? '',
          }
          : {
            address1: data.address1 ?? '',
            address2: data.address2 ?? '',
            city: data.city ?? '',
            state: data.state ?? '',
            pinCode: data.pincode ?? '',
            country: data.country ?? '',
          },
        currentAddressEqualsPermanent: data.isDifferentPermanentAddress ? 'NO' : 'YES',
        resume: data.resume ?? null,
      },
    },
  };

  return transformedData;
};

export const reverseTransformPersonalInformation = (data = {}) => {
  const currentAddress = data.currentAddress ?? {};
  const permanentAddress = data.permanentAddress ?? {};
  const phoneNumbers = [data.primaryPhoneNumber, ...(data.alternatePhoneNumbers ?? [])];
  const emailIds = [data.primaryEmailId, ...(data.alternateEmailIds ?? [])];

  let transformedData = {
    displayPic: data.displayPic ?? null,
    salutation: data.salutation ?? '',
    firstName: data.firstName ?? '',
    middleName: data.middleName ?? '',
    lastName: data.lastName ?? '',
    dob: data.dateOfBirth ? new Date(data.dateOfBirth) : null,
    gender: data.gender ?? '',
    maritalStatus: data.maritalStatus ?? '',
    phoneNumbers: parsePhoneNumbers(phoneNumbers),
    emailIds: emailIds,
    address1: currentAddress.address1 ?? '',
    address2: currentAddress.address2 ?? '',
    city: currentAddress.city ?? '',
    state: currentAddress.state ?? '',
    country: currentAddress.country ?? '',
    pincode: currentAddress.pinCode ?? '',
    permAddress1: permanentAddress.address1 ?? '',
    permAddress2: permanentAddress.address2 ?? '',
    permCity: permanentAddress.city ?? '',
    permState: permanentAddress.state ?? '',
    permPincode: permanentAddress.pinCode ?? '',
    permCountry: permanentAddress.country ?? '',
    isDifferentPermanentAddress: data.currentAddressEqualsPermanent === 'NO',
    resume: data.resume ?? [],
  };

  return transformedData;
};